import { useEffect, useRef } from "react";
import * as journifyTrackingCarEvents from "../services/trackingCarEvents";

const pick = (obj, keys, fallback = undefined) => {
  for (const k of keys) {
    if (obj && obj[k] !== undefined && obj[k] !== null) return obj[k];
  }
  return fallback;
};

const toNumber = (v, def = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : def;
};

const toString = (v, def = "") => (v === undefined || v === null ? def : String(v));


export default  function useTrackViewCarList({
  listId,
  listName,
  cars,
  currency = "SAR",
  creativeSlot, // اختياري لو تبي تربطه بمكان الظهور
}) {
  const firedRef = useRef("");

  useEffect(() => {
    if (!listId || !listName) return;
    if (!Array.isArray(cars) || cars.length === 0) return;

    // منع تكرار نفس التتبع (خصوصاً في React StrictMode)
    const first = cars[0];
    const key = `${listId}-${listName}-${cars.length}-${first?.slug || first?.productId || ""}`;
    if (firedRef.current === key) return;
    firedRef.current = key;

    const items = cars.map((car, idx) => ({
      // أهم شي: ID + Name
      item_id: toString(car?.productId ?? car?.slug, ""),
      item_name: toString(car?.name ?? car?.modelTypes, ""),

      affiliation: "value",
      coupon: "value",
      discount: 0,
      index: idx,

      // Brand / Categories
      item_brand: toString(car?.brand, "value"),
      item_category: toString(car?.group, "value"),       // مثل: RAIZE / Corolla / Camry
      item_category2: toString(car?.year, "value"),       // مثل: 2026
      item_category3: toString(car?.category, "value"),   // مثل: سيدان / SUV
      item_category4: toString(car?.carGroupID, "value"), // مثل: GR30
      item_category5: toString(car?.type, "value"),       // مثل: TN1386

      // الأفضل تكون نفس القائمة (بدل "value")
      item_list_id: toString(listId),
      item_list_name: toString(listName),

      // variant ممكن تستخدم modelTypes أو type
      item_variant: toString(car?.modelTypes ?? car?.type, "value"),

      location_id: toString(creativeSlot, "value"),

      price: toNumber(car?.minPrice, 0),
      quantity: 1,
    }));
    
    journifyTrackingCarEvents.trackViewCarList(toString(listId), toString(listName),items, currency);

  }, [listId, listName, cars, currency, creativeSlot]);
}

